import React from "react"
import { makeStyles } from "tss-react/mui"
import { Button, Tooltip } from "@mui/material"
import { faPlus } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { tailwindPalette } from "../../../modules/theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    buttonIcon: {
        fontSize: "1.025rem !important",
    },
    createButton: {
        borderRadius: ".5rem",
        boxShadow: "0px 3px 1px -2px #00000033,  0px 2px 2px 0px #00000024, 0px 1px 5px 0px #0000001F",
        textTransform: "none",
        padding: ".5rem 1.375rem",
        backgroundColor: tailwindPalette.teal[500],
        "&:hover": {
            backgroundColor: tailwindPalette.teal[700],
        },
    },
}))

type TopBarNewButtonProps = Readonly<{
    onClick: (event: React.MouseEvent<HTMLElement>) => void
}>

export function TopBarNewButton({ onClick }: TopBarNewButtonProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="new-order-tooltip-text" attrs={{ title: true }}>
            <Tooltip title="Create new order">
                <Button
                    data-tour="merchant-product-tour-new"
                    startIcon={<FontAwesomeIcon className={classes.buttonIcon} icon={faPlus} />}
                    onClick={onClick}
                    variant="contained"
                    className={classes.createButton}
                >
                    <LocalizedStrict id="top-bar-new-button">
                        <>New</>
                    </LocalizedStrict>
                </Button>
            </Tooltip>
        </LocalizedStrict>
    )
}
